<template>
  <div class="whole q-mt-xl q-ml-md " v-if="isAuthenticated == true">

    <div class="row">
      <div class="col " id="firsttab">

        <q-card>
          <q-tabs v-model="tab" no-caps indicator-color="yellow" narrow-indicator>

            <q-tab name="market">
              <div class="row">
                <div class="col">Ad Summary</div>
                <div class="infoicon col q-ml-lg"><i class="fa fa-info-circle" style="font-size:10px"
                    aria-hidden="true">
                    <q-tooltip>
                      <P>
                        Calculated from metrics 1 day before from all the campaigns </P>
                    </q-tooltip>
                  </i></div>
              </div>
            </q-tab>
          </q-tabs>
        </q-card>
      </div>
      <div class="col q-mt-sm">
        <q-btn-dropdown class="col prdctq " :label="profile_label" style="color: black;font-size:15px;">
          <q-list>
            <q-item clickable v-for="item in Object.keys(reponseData)" :key="item" v-close-popup
              @click="get_data(item)">
              <q-item-section>
                <q-item-label @click="trackingbutton(item)">{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </div>

    </div>
    <q-tab-panels v-model="tab" animated class="margin1">
      <q-tab-panel name="market">
        <div class="info">
          <div v-if="matrix == true" class="nodata">
            <h5>No metrics available .</h5>

          </div>
          <div v-if="line == true" class="generating">
            <h5>Report is generating ... Please check after some time .</h5>

          </div>

          <div class="details q-ml-sm q-mr-sm" v-if="table == true">
            <q-table ref="table" disable-pagination hide-bottom :data="rows1" separator="none" :columns="columns1"
              row-key="category" class="table1 q-mb-sm">
              <template v-slot:header="props">
                <q-tr :props="props" class="title">
                  <q-th key="CPC" :props="props">
                    {{ Object.keys(tabledata[0])[0] }}
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip class="tooltip">
                        <P style="font-size:15px">Cost-per-click (CPC)</P>
                        <P>This is the average amount you paid for each click on an ad.</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="CTR" :props="props">
                    {{ Object.keys(tabledata[0])[1] }}
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Click-through rate (CTR)</P>

                        <P>The ratio of how often shoppers click on your ad when displayed. This is calculated as clicks
                          divided by impressions.</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="ACOS" :props="props">
                    {{ Object.keys(tabledata[0])[2] }}
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Advertising cost of sales (ACOS)</P>
                        <P>
                          ACOS is the percent of attributed sales spent on advertising within 14 days of clicks on your
                          ads. This is calculated by dividing total spend by attributed sales.</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="ROAS" :props="props">
                    {{ Object.keys(tabledata[0])[3] }}
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Return on ad spend (ROAS)</P>
                        <P>
                          The total revenue you received yesterday from your advertising investment. This is calculated
                          by dividing sales attributed to your ads by your spend. Attribution varies by campaign type.
                        </P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="cost" :props="props">
                    COST
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Cost</P>

                        <P>The total click charges for a product ad.</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="clicks" :props="props">
                    CLICKS
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Clicks</P>
                        <P>Clicks
                          The number of times your ads were clicked. Note: Once identified, it may take up to 3 days to
                          remove invalid clicks.</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="sales" :props="props">
                    SALES
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Sales</P>

                        <P>Sales is the total value of products sold to shoppers within the specified time frame for a
                          type of campaign due to clicks or views of your ads.

                        </P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="impressions" :props="props">
                    IMPRESSIONS
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Impressions</P>

                        <P>The number of times ads were displayed</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="CPC" :props="props">
                    AD CONVERSIONS
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px"> Ad Conversions</P>

                        <P>Number of attributed conversion events occurring within 24 hours of ad click where the
                          purchased SKU was the same as the SKU advertised.</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                </q-tr>
              </template>

              <template v-slot:body="props">


                <q-tr :props="props" class="body">
                  <q-td key="CPC" :props="props">
                    {{ tabledata[0]["CPC"] }}


                  </q-td>
                  <q-td key="CTR" :props="props">
                    {{ tabledata[0]["CTR"] }}

                  </q-td>
                  <q-td key="ACOS" :props="props">
                    {{ tabledata[0]["ACOS"] }}

                  </q-td>
                  <q-td key="ROAS" :props="props">
                    {{ tabledata[0]["ROAS"] }}

                  </q-td>
                  <q-td key="cost" :props="props">
                    {{ tabledata[0]["cost"] }}

                  </q-td>
                  <q-td key="clicks" :props="props">
                    {{ tabledata[0]["clicks"] }}

                  </q-td>
                  <q-td key="sales" :props="props">
                    {{ tabledata[0]["sales14d"] }}

                  </q-td>
                  <q-td key="impressions" :props="props">
                    {{ tabledata[0]["impressions"] }}

                  </q-td>
                  <q-td key="ad_conversions" :props="props">
                    {{ tabledata[0]["Ad Conversion"] }}

                  </q-td>



                </q-tr>

              </template>
            </q-table>

          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>

    <div class="q-mt-xl q-ml-lg">

      <h5 class="top5">TOP 5 PERFORMANCE</h5>

    </div>
    <div>
      <q-card class="tabpanel">
        <q-tabs v-model="tab1" no-caps class="secondtab" active-color="black" indicator-color="yellow" narrow-indicator>

          <q-tab name="topsale1">
            <div class="row">
              <div class="col" style="height:100%">Top 5 Ad Campaigns </div>
              <div><i class="fa fa-info-circle q-ml-sm" style="font-size:10px" aria-hidden="true">
                  <q-tooltip>


                    <P>

                      Ranking of campaigns based on 14 day average Ad conversion Rate

                    </P>
                  </q-tooltip>
                </i></div>
            </div>
          </q-tab>
          <!-- <q-tab name="topsale2" >TOP 5 AD SPEND</q-tab> -->






        </q-tabs>
      </q-card>
    </div>
    <q-tab-panels v-model="tab1" animated>
      <q-tab-panel name="topsale1">
        <div class="info">
          <div v-if="matrix1 == true" class="nodata">
            <h5>No metrics available .</h5>

          </div>
          <div v-if="line1 == true" class="generating">
            <h5>Report is generating ... Please check after some time .</h5>

          </div>

          <div class="details1 q-ml-sm q-mb-sm" v-if="table1 == true">
            <q-table ref="table" disable-pagination hide-bottom :data="rows2" separator="none" :columns="columns2"
              row-key="category" class="table">
              <template v-slot:header="props">
                <q-tr :props="props" class="title1">

                  <q-th key="campaignName" :props="props">
                    CAMPAIGN NAME
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Campaign Name</P>

                        <P>Name of Campaign</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="campaignName" :props="props">
                    CLICKS
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Click-through rate (CTR)</P>

                        <P>The number of times your ads were clicked. Note: Once identified, it may take up to 3 days to
                          remove invalid clicks.</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="clicks" :props="props">
                    14 DAYS PURCHASES
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">14 days purchases</P>

                        <P>

                          Number of attributed conversion events occurring within 14 days of an ad click.</P>
                      </q-tooltip>
                    </i>
                  </q-th>
                  <q-th key="campaignName" :props="props">
                    CONVERTION RATE
                    <i class="fa fa-info-circle" aria-hidden="true">
                      <q-tooltip>
                        <P style="font-size:15px">Convertion Rate</P>

                        <P>

                          Number of attributed conversion events occurring within 14 days of ad click where the
                          purchased SKU was the same as the SKU advertised.This is calculated by dividing 14day
                          purchases by your clicks

                        </P>
                      </q-tooltip>
                    </i>
                  </q-th>
                </q-tr>
              </template>

              <template v-slot:body="props">
                <q-tr v-for="v in length1" :key="v" :props="props" class="body">
                  <q-td key="campaignName" :props="props" style="color:black">
                    {{ tabledata[1]["campaignName"][v - 1] }}


                  </q-td>
                  <q-td key="clicks" :props="props" style="color:black">
                    {{ tabledata[1]["clicks"][v - 1] }}


                  </q-td>
                  <q-td key="purchases14d" :props="props" style="color:black">
                    {{ tabledata[1]["purchases14d"][v - 1] }}


                  </q-td>
                  <q-td key="Convertion Rate" :props="props" style="color:black">
                    {{ tabledata[1]["Convertion Rate"][v - 1] }}


                  </q-td>

                </q-tr>

              </template>
            </q-table>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
    <q-tab-panels v-model="tab1" animated>
      <q-tab-panel name="topsale2">
        <div class="info">
          <div class="details">

            <q-table ref="table" disable-pagination hide-bottom :data="rows3" separator="none" :columns="columns3"
              row-key="category" class="table">
              <template v-slot:header="props">
                <q-tr :props="props" class="title">

                  <q-th v-for="col in props.cols" :key="col.name" :props="props" class="head">
                    {{ col.label }}
                  </q-th>
                </q-tr>
              </template>

              <template v-slot:body="props">
                <q-tr :props="props">

                  <q-td v-for="col in props.cols" :key="col.name" :props="props"
                    style="background-color:white;margin-top: 100px;">

                  </q-td>


                </q-tr>

              </template>
            </q-table>

          </div>
        </div>
      </q-tab-panel>

    </q-tab-panels>

    <div style="margin-left:38%;margin-top: 1.5rem;">
      <q-btn class="btn" style="background: #0f2587 0% 0% no-repeat padding-box;
                            border-radius: 4px;
                            color:#f0eeee;
                            margin-right:2rem;" @click="generatePDF()">Generate Report</q-btn>
      <q-btn class="btn" style="background: #0f2587 0% 0% no-repeat padding-box;
                        border-radius: 4px;
                        color:#f0eeee;
                        margin-right:2rem;" @click="sendMail()">Mail Report</q-btn>
    </div>

    <div style="margin-left:38%;margin-top: 1.5rem;">
      <q-btn class="btn" style="background: #0f2587 0% 0% no-repeat padding-box;
                            border-radius: 4px;
                            color:#f0eeee;
                            margin-right:2rem;" @click="generatePDF()">Generate Report</q-btn>
      <q-btn class="btn" style="background: #0f2587 0% 0% no-repeat padding-box;
                        border-radius: 4px;
                        color:#f0eeee;
                        margin-right:2rem;" @click="sendMail()">Mail Report</q-btn>
    </div>
  </div>
</template>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400&display=swap');
@import url('https://fonts.googleapis.com/css?family=Raleway');
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
.q-tab-panel {
  padding: 0px !important;
  background-color: transparent !important;
}
.head {
  position: relative;
}
.q-tab-panels {
  background-color: transparent !important;
}
.nodata {
  color: red;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 25px;
  margin-bottom: 25px;
  font-size: 12px;
  font-family: "Poppins", sans-serif !important;
}
.whole {
  font-family: "Poppins", sans-serif;
}
.generating {
  color: blue;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 25px;
  margin-bottom: 25px;
  font-size: 12px;
  font-style: italic;
  font-family: "Poppins", sans-serif !important;
}
.margin1 {
  margin-top: 80px;
}
.q-table th,
.q-table td {
  padding: 0px 0px;
  background-color: inherit;
}
.q-table th,
.q-table td {
  background-color: inherit;
}
.q-table th {
  padding: 0px 20px;
  background-color: inherit;
}
.heading {
  /* UI Properties */
  background: #F4F7FC 0% 0% no-repeat padding-box;
  box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
}
#firsttab {
  margin-left: -310px;
  /* UI Properties */
  font: normal normal bold 20px/24px Raleway;
  letter-spacing: 0px;
  color: #11141A;
  opacity: 1;
}
.q-card {
  box-shadow: none !important;
  border-radius: 0px;
  vertical-align: top;
  background: none;
  position: relative;
}
.wp-block-ub-tabbed-content-tabs-content {
  border: 0;
  background: none;
}
.title {
  background: #F4F7FC 0% 0% no-repeat padding-box;
  box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
}
.title1 {
  background: white 0% 0% no-repeat padding-box;
}
.top5 {
  font: normal normal bold 18px/32px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  text-transform: uppercase;
  opacity: 1;
  margin-left: -20px;
}
.table {
  width: 100%;
  text-transform: uppercase;
}
.body {
  border-radius: 10px 10px 0px 0px;
  opacity: 1;
  background-color: white;
}
.q-table th {
  font-weight: 600;
  font-size: 12px;
}
.q-table__card {
  color: #000;
  border-radius: 10px;
}
.head {
  font: normal normal 600 18px/32px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  text-transform: capitalize;
  opacity: 1;
}
.secondtab {
  margin-top: 20px;
  width: 300px;
  height: 40px;
  text-align: left;
  font: normal normal bold 17px/20px Montserrat;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
  margin-left: -50px;
}
.tabpanel {
  background: #C6CDD1 0% 0% no-repeat padding-box;
  border-radius: 10px 10px 0px 0px;
  margin-right: 10px;
  height: 54px;
}
.details {
  margin-top: 1px;
}
.details1 {
  margin-left: 1px;
}
.infoicon {
  margin-left: 30px;
}
</style>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
export default {
  data() {
    return {
      isAuthenticated: false,
      preview: false,
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      tab: 'market',
      tab1: 'topsale1',
      profile_label: "Select Profile",
      profile_id: "",
      products: [],
      reponseData: [],
      tabledata: [],
      matrix: false,
      table: false,
      line: false,
      matrix1: false,
      table1: false,
      line1: false,
      length1: '',
      columns1: [
        {
          name: "CPC",
          required: true,
          label: "CPC",
          align: "center",
          field: "CPC",
        },
        {
          name: "CTR",
          required: true,
          label: "CTR",
          align: "center",
          field: "CTR",
        },
        {
          name: "ACOS",
          required: true,
          label: "ACOS",
          align: "center",
          field: "ACOS",
        },
        {
          name: "ROAS",
          required: true,
          label: "ROAS",
          align: "center",
          field: "ROAS",
        },
        {
          name: "cost",
          required: true,
          label: "Cost",
          align: "center",
          field: "cost",
        },
        {
          name: "clicks",
          required: true,
          label: "Clicks",
          align: "center",
          field: "clicks",
        },
        {
          name: "sales",
          required: true,
          label: "Sales",
          align: "center",
          field: "sales",
        },
        {
          name: "impressions",
          required: true,
          label: "Impressions",
          align: "center",
          field: "impressions",
        },
        {
          name: "ad_conversions",
          required: true,
          label: "Ad Conversions",
          align: "center",
          field: "ad_conversions",
        },
      ],
      rows1: [
        {
          CPC: '',
          CTR: '',
          ACOS: '',
          ROAS: '',
          cost: '',
          clicks: '',
          sales14d: '',
          impressions: '',
          ad_conversions: ''
        },
      ],
      columns2: [
        {
          name: "campaignName",
          required: true,
          label: "CAMPAIGN NAME",
          align: "center",
          field: "campaignName",
        },
        {
          name: "clicks",
          required: true,
          label: "CLICKS",
          align: "center",
          field: "clicks",
        },
        {
          name: "purchases14d",
          required: true,
          label: "14 DAYS PURCHASE",
          align: "center",
          field: "purchases14d",
        },
        {
          name: "Convertion Rate",
          required: true,
          label: "CONVERTION RATE",
          align: "center",
          field: "Convertion Rate",
        },
      ],
      rows2: [
        {
          campaignName: '',
          clicks: '',
          purchases14d: '',
          ConvertionRate: '',
        }
      ],
      columns3: [
        {
          name: "campaign_name",
          required: true,
          label: "CAMPAIGN NAME",
          align: "center",
          field: "campaignname",
        },
        {
          name: "ad_sales",
          required: true,
          label: "AD SALES",
          align: "center",
          field: "adsales",
        },
        {
          name: "ad_spend",
          required: true,
          label: "AD SPEND",
          align: "center",
          field: "adspend",
        },
      ],
      rows3: [
        {
          campaignname: '',
          adsales: '',
          adspend: '',
        },
        {
          campaignname: '',
          adsales: '',
          adspend: '',
        }
      ]
    }
  },
  mounted() {
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    if (this.$cookies.isKey("login_authentication")) {
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      //console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$store.dispatch("setPathName", "/amazonadoptimization/adsummary");
        this.$q.loading.hide();
        this.isAuthenticated = true;
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication1")) {
      let encryptedText = this.$cookies.get("login_authentication1");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      //console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication2")) {
      let encryptedText = this.$cookies.get("login_authentication2");
      const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
      //console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$store.dispatch("setPathName", "/amazonadoptimization/adsummary");
        this.$q.loading.hide();
        this.isAuthenticated = true;
      }
      else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }
    var productsURL = this.api_url + "/amazon-ad/get_profiles/" + this.$org_id.label;
    this.$http
      .post(productsURL)
      .then((response) => {
        let result = response.data;
        this.reponseData = response.data;
        this.$q.loading.hide();
      })
      .catch((err) => {
        this.$q.loading.hide();
        this.$q.notify({
          message: err,
          color: "negative",
        });
        //console.log(err);
      });
  },
  methods: {
    trackingbutton(items){
      this.$mixpanel.track('Keyword Analysis/CampaignNames',{
        info : `user selected ${items} this Campaign`
      })
    },
    generatePDF() {
      this.$mixpanel.track('Keyword Analysis/GenerateReport',{
        info : `user Generated Report`
      })
      const element = document.getElementById('screenshot');

            const scale = window.devicePixelRatio;
      const options = {
        scale: scale
      };

        html2canvas(element,options).then(canvas => {
          const pdf = new jsPDF();
          const imgData = canvas.toDataURL('image/png', 1.0);
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const ratio = imgProps.height / imgProps.width;
        const imgWidth = pdfWidth;
        const imgHeight = pdfWidth * ratio;
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        
      
          pdf.save("Report.pdf");
          //console.log(pdf);
          // var formData1 = new FormData();
          // formData1.append('file');
        });
  },
  sendMail() {
    this.$mixpanel.track('Keyword Analysis/MailReport',{
        info : `user Mailed the Report`
      })

    this.$q.loading.show({
      message: "Sending Mail..",
    });
      const element = document.getElementById('screenshot');

            const scale = window.devicePixelRatio;
      const options = {
        scale: scale
      };

        html2canvas(element,options).then(canvas => {
          const pdf = new jsPDF();
          const imgData = canvas.toDataURL('image/png', 1.0);
                let postURL = this.api_url + `/amazon-ad/amazonadperformance/uploadfile/` + this.$org_id.label;

                //console.log(postURL)
                this.$http
                .post(postURL,[{'dataUrl' : imgData }])
                .then((response)=>{
                

                  this.$q.loading.hide();
                    //console.log(response)
                  this.seamless = true;
            
            });

        });
  },
    get_data(details) {
      this.profile_label = details;
      this.profile_id = this.reponseData[this.profile_label]
      var productURL = this.api_url + "/amazon-ad/get_ad_summary/" + this.profile_id + "/" + this.$org_id.label;
      this.$http
        .post(productURL)
        .then((response) => {
          let result = response.data;
          this.tabledata = result;
          if (Object.keys(result[0]).length > 0) {
            this.table = true;
            this.line = false;
            this.matrix = false;
            this.$q.loading.hide();
          }
          //  this.column1=result["acos"];
          else if (result[0] == false) {
            this.line = true;
            this.matrix = false;
            this.table = false;
          }
          else {
            this.matrix = true;
            this.table = false;
            this.line = false;
          }
          if (Object.keys(result[1]).length > 0) {
            this.table1 = true;
            this.line1 = false;
            this.matrix1 = false;
            this.length1 = Object.keys(this.tabledata[1]["campaignName"]).length;
          }
          //  this.column1=result["acos"];
          else if (result[1] == false) {
            this.line1 = true;
            this.matrix1 = false;
            this.table1 = false;
          }
          else {
            this.matrix1 = true;
            this.table1 = false;
            this.line1 = false;
          }
          // this.backupList = data;
        })
        .catch((err) => {
          this.$q.loading.hide();
          this.$q.notify({
            message: err,
            color: "negative",
          });
          //console.log(err);
        });
    },
  }
}

</script>

